// A vertical encode's picture (config/vertical.go): rotated, or composited
// on a background with a graphic over it. The box is ffcmd.PictureBox's.
export interface Vertical {
    mode: 'rotate' | 'composite'
    rotate?: '' | 'ccw'
    background_media_id?: string
    picture_width?: number
    top?: number // composite: the picture's top edge; none: centred
    overlay_media_id?: string
}

// the frame sizes offered for a vertical encode: 9:16 HD and Full HD, 4:5, 1440p
export const verticalSizes = ['720x1280', '1080x1920', '1080x1350', '1440x2560']

const even = (n: number) => n - (n % 2)

// where a composite puts the input's picture: its size at the input's
// aspect (16:9 when not known) and its top, inside the frame, even
export function pictureBox(
    frameW: number,
    frameH: number,
    inW: number,
    inH: number,
    pictureWidth?: number,
    top?: number,
): { w: number; h: number; top: number } {
    const w = pictureWidth || frameW
    const h = Math.min(even(Math.floor(inW > 0 && inH > 0 ? (w * inH) / inW : (w * 9) / 16)), frameH)
    const y = top === undefined ? Math.floor((frameH - h) / 2) : Math.min(top, frameH - h)
    return { w, h, top: even(y) }
}

// what a form's vertical settings save as: only the mode's own
export function verticalBody(v: Vertical | undefined): Vertical | undefined {
    if (!v) return undefined
    if (v.mode === 'rotate') return { mode: 'rotate', rotate: v.rotate || undefined }
    return {
        mode: 'composite',
        background_media_id: v.background_media_id || undefined,
        picture_width: Number(v.picture_width) || undefined,
        top: v.top === undefined || (v.top as unknown) === '' ? undefined : Number(v.top),
        overlay_media_id: v.overlay_media_id || undefined,
    }
}
